import { api } from "./api";
import { ControlDate } from "../types/controle-datas";
import { dedupedFetch } from "./cache";

const fetchControlDates = async(): Promise<ControlDate[]> => {
    return dedupedFetch("control-dates", async () => {
        const { data } = await api.get('/database/controle_datas__c');

        if (!Array.isArray(data)) {
            return [];
        } else {
            return data;
        }
    }, 120_000);
}

const GeneralItens = async(existingControlDates?: ControlDate[]) =>{
    try{
        const hasControlDates = existingControlDates && existingControlDates.length > 0;
        const controlDates = hasControlDates
            ? existingControlDates
            : await fetchControlDates();

        return { controlDates };

    }catch(e){
        throw e;
    }
}

export default GeneralItens;
export { fetchControlDates };
